<template>
    <div class="main-page">
        <div class="map flex-auto min-w-0" ref="elemMap"></div>
        <InfoWindow v-if="isShowInfoWindow" :selectedPlace="selectedPlace" :tripInfo="tripInfo" />
    </div>
</template>

<script>
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';
import { defineComponent, inject, nextTick, onMounted, ref } from 'vue';
import MapsService from '../service/MapsService';
import ConfigManager from '@/config/ConfigManager';
import SearchModel from '@/module/Search/model/SearchModel';
import useSearchService from '@/module/Search/service/useSearchService';

// import icons
import IconMapPinNormal from "@/assets/icon/ic-pin-location-solid.svg"
import IconMapPinActive from "@/assets/icon/ic-pin-location-active.svg"
import IconMapUserPosition from "@/assets/icon/ic-current-location-pointer.svg"

// component
import InfoWindow from '../component/InfoWindow.vue';

export default defineComponent({
    setup: function () {
        const searchService = useSearchService()

        const modalStore = inject("ModalStore");
        const { loadingModal } = useLoadingModal(modalStore);
        const selectedPlace = ref()
        const tripInfo = ref()
        const places = ref([])

        //#region google maps
        const markerConfig = {
            useActiveIcon: true,
            iconWidth: 17,
            iconHeight: 24,
            activeIconWidth: 21.9,
            activeIconHeight: 38.2,
            normalIcon: IconMapPinNormal,
            activeIcon: IconMapPinActive
        }
        const elemMap = ref(null);
        let googleKey = ConfigManager.getGoogleMapsKey();
        const isShowInfoWindow = ref(false)
        const mapService = MapsService(elemMap, {
            apiKey: googleKey,
            version: "weekly",
            libraries: ["places"]
        }, {
            zoom: 14
        });
        //#endregion google maps

        const renderMarkers = function () {
            for (const place of places.value) {
                /**@type {import("@/module/Search/model/PlaceModel").PlaceModel} */
                const info = place
                let pos = { lat: info.location.latitude, lng: info.location.longitude }
                mapService.addMarker(pos, () => {
                    selectedPlace.value = place
                    mapService.getDistanceInfo(pos).then((info) => {
                        tripInfo.value = info

                        // show info modal
                        nextTick(() => {
                            isShowInfoWindow.value = true
                        })
                    })
                }, markerConfig);
            }
        }

        const getPlaces = function () {
            let searchModel = new SearchModel().loadCache()
            return searchService.searchPlaces(searchModel.getParams()).then((items) => {
                places.value = items

                renderMarkers()
            })
        }

        onMounted(() => {
            loadingModal.show();
            mapService.getCurrentLocation().then(() => {
                return mapService.initMaps();
            }).then(() => {
                mapService.pinCurrent(null, IconMapUserPosition, 48, 48)
                return getPlaces()

            }).finally(() => {
                loadingModal.hide();
            });
        });
        return {
            selectedPlace,
            tripInfo,
            elemMap,
            isShowInfoWindow
        };
    },
    components: { InfoWindow }
})
</script>

<style lang="scss" scoped>
@import "@/style/animation/modal-animation.scss";

.main-page {
    @apply mx-auto flex flex-col w-full h-screen max-h-screen bg-a-gray-efefef font-main max-w-lg;
}
</style>